import React, { useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FaLock } from 'react-icons/fa';
import { RCard, RIconText } from '@putil-view/item.components';
import {
	ScanLockerQrCode,
	RequestLockerByUuid,
	ConfirmForm,
	UploadUnclearData,
	DisplayResult
} from './components';
import 'css/qr-unlock.css';

const QrUnclear = () => {
	const uuid = useRef('');
	const [state, setState] = useState({ result: null, scanText: '', stage: "SCAN_LOCKER_QR_CODE" })
	const stage = state.stage;
	const onRestart = () => {
		uuid.current = ''; 
		setState({ result: null, scanText: '', stage: "SCAN_LOCKER_QR_CODE" })
	}

	return (
		<Row className="mt-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0 pr-0 align-self-start pt-4">
			<Col xl={12} lg={12} md={12} sm={12} xs={12} className="qr-unlock-col">
				<RCard title={
					<RIconText variant="lg">
						<FaLock />
						<span>Unclear Locker {state.scanText}</span>
					</RIconText>
				}>
					{state.stage === "SCAN_LOCKER_QR_CODE" &&
						<ScanLockerQrCode state={state} setState={setState} uuid={uuid} />
					}
					{state.stage === "REQUEST_LOCKER_BY_UUID" &&
						<RequestLockerByUuid setState={setState} uuid={uuid} />
					}
					{stage === "DATA_CONFIRM" &&
						<ConfirmForm state={state} setState={setState} onRestart={onRestart} />
					}
					{stage === "UPLOAD_UNCLEAR_DATA" &&
						<UploadUnclearData state={state} setState={setState} uuid={uuid} />
					}
					{stage === "DISPLAY_RESULT" &&
						<DisplayResult state={state} onRestart={onRestart} />
					}
				</RCard>
			</Col>
		</Row>
	);
}
export default QrUnclear;
